import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
})
export class ProfilePictureComponent implements OnInit {
  @ViewChild('pic') pic: ElementRef;
  @Input() avatarUrl;
  @Input() imgSize = 100;
  imgRatio = '100';
  constructor() { }

  ngOnInit() { }
  onLoad() {
    let ratio;
    if ((this.pic.nativeElement as HTMLImageElement).naturalWidth > (this.pic.nativeElement as HTMLImageElement).naturalHeight) {
      ratio =
        ((this.pic.nativeElement as HTMLImageElement).naturalWidth / (this.pic.nativeElement as HTMLImageElement).naturalHeight) * 100;
    } else {
      ratio =
        ((this.pic.nativeElement as HTMLImageElement).naturalHeight / (this.pic.nativeElement as HTMLImageElement).naturalWidth) * 100;
    }
    this.imgRatio = ratio.toString();
  }
}
